import {threatSearchValues} from './threatSearchValues';

export const fromObjectToQueryString = (obj: Record<string, any>): string =>
    Object.keys(obj).reduce((acc, key) => `${acc}&${key}=${threatSearchValues(key, obj[key])}`, '');
